var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Invite"},[_c('label',{attrs:{"for":""}},[_vm._v("学校/机构：")]),_c('my_input',{attrs:{"inputStyle":_vm.style},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }